module.exports = __webpack_public_path__ + "statics/img/01.d8ebf2a4.png";